// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__3EpBh","text":"styles_text__Er5Xj","icon":"styles_icon__Lrv0C"};